import axios from 'axios';
import { user } from '../store';
import apiClientConfig from './config';

const API = apiClientConfig[process.env.NODE_ENV || 'development'];
const PLATFORM = {
  plat: 'wa',
  plat_name: 'jsyzh'
};

const MP_PLATFORM = {
  plat: 'wp',
  plat_name: 'jsysdy'
};

export type Method = 'GET' | 'POST' | 'PUT' | 'DELETE';

export interface APIConfig {
  defaultToken?: string;
}

async function apiRequest(
  method: Method,
  url: string,
  data: any,
  config: APIConfig
) {
  let requestData = data;
  let params = data;

  if (method === 'GET') {
    requestData = null;
  } else {
    params = null;
  }

  const token = user.token;

  const response = await axios(url, {
    data,
    headers: {
      token: data.token || token
    },
    method,
    params
  });

  if (response.data.status === 80003) {
    user.login();
  }

  return response.data;
}

function createClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return (data?: any, apiConfig: APIConfig = {}) => {
    const config = {
      ...defaultConfig,
      ...apiConfig
    };

    const requestData = {
      ...defaultData,
      ...data
    };

    return apiRequest(method, url, requestData, config);
  };
}

function createBaseClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return createClient(method, API.BASE_HOST + url, defaultData, defaultConfig);
}

const apiClient = {
  base: {
    /**
     * 资产信息
     * 0041
     */
    account: createBaseClient('GET', '/v1/account', PLATFORM),
    // 0066 - 登录
    login: createBaseClient('POST', '/v1/member', { action: 'login' }),
    // 0011.2 - 授权登录
    oauth: ({ route = '', mp = '' } = { route: '', mp: '' }) => {
      // 记录用户进行了 oauth 操作，以便后续决定是否要接受 token
      localStorage.setItem('oauth', 'true');

      const host = route
        ? window.location.host + route
        : window.location.host + window.location.pathname + window.location.search;

      let plat = '';
      let platName = '';

      if (mp) {
        plat = 'wp';
        platName = mp;
      }

      const url =
        API.OAUTH_URL +
        `?host=${encodeURIComponent(host)}&plat_name=${platName}&plat=${plat}`;

// console.log(window.location)
// console.log(url)
      window.location.href = url;
    },
    /**
     * 购买积分
     *  0126
     */
    purchaseScores: createBaseClient('GET', '/v1/score', MP_PLATFORM),
    /**
     * 积分配置
     * 0165
     *
     */
    scoresConfig: createBaseClient('GET', '/v1/config'),
    /**
     * 积分充值列表
     * 0125
     */
    scoresRechargeList: createBaseClient('GET', '/v1/score', PLATFORM),
    // 0061 - 用户信息
    userinfo: createBaseClient('GET', '/v1/member', PLATFORM),
    // 0015 - 微信签名
    weixinSign: createBaseClient('GET', '/v1/weixin', MP_PLATFORM),


    // 0008-意见反馈
    advice: createBaseClient('POST', '/v1/advice', PLATFORM),

    // 11029-跳转小程序连接 plat_name, plat
    wechatScheme: createBaseClient('POST', '/v1/wechat', {action: 'scheme'}),

    /**
     * 0361-文章列表
     * page,  type: 1：常见问题	
     * 0362-文章详情
     * id
     */
    articleGet: createBaseClient('GET', '/v1/article'),


    /**
     * 0291-超级会员
     */
    vipPlus: createBaseClient('GET', '/v1/vipPlus', {action: 'list', ...PLATFORM}),
    /**
     * 0291-超级会员
     * id: 会员id
     */
    vipPlusBuy: createBaseClient('GET', '/v1/vipPlus', MP_PLATFORM),
    /**
     * 0293-会员信息
     */
    vipPlusInfo: createBaseClient('GET', '/v1/vipPlus', PLATFORM),
    /**
      * 0294-赠送活动
      * type: 1为替班
    */
    vipPlusActivity: createBaseClient('GET', '/v1/vipPlus', {action: 'activity', ...PLATFORM}),
  }
};

export default apiClient;
